// react
import PropTypes from "prop-types";
import React from "react";

// animations
import StatusAnimation from "./StatusAnimation";

// config
import Config from "../../Config";

export default class Status extends React.Component {
	static propTypes = {
		size: PropTypes.number,
		elementSize: PropTypes.number,
		children: PropTypes.string.isRequired,
	};

	static defaultProps = {
		size: Config.wrapperSize,
		elementSize: Config.elementSize,
	};

	constructor(props) {
		super(props);

		this.svgAnimation = null;

		this.handleTeardown = this.handleTeardown.bind(this);
		this.runBuildingAnimation = this.runBuildingAnimation.bind(this);
	}

	componentDidMount() {
		const { children } = this.props;

		if (children === "running") {
			this.runBuildingAnimation();
		} else if (children === "idle") {
			this.runIdlingAnimation();
		} else if (children === "error") {
			this.runErrorAnimation();
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.children !== this.props.children && this.props.children === "running") {
			this.handleTeardown();
			this.runBuildingAnimation();
		} else if (prevProps.children !== this.props.children && this.props.children === "idle") {
			this.handleTeardown();
			this.runIdlingAnimation();
		} else if (prevProps.children !== this.props.children && this.props.children === "error") {
			this.handleTeardown();
			this.runErrorAnimation();
		}
	}

	componentWillUnmount() {
		this.handleTeardown();
	}

	handleTeardown() {
		if (this.svgAnimation) {
			this.svgAnimation.finish();
		}
	}

	runBuildingAnimation() {
		const { elementSize } = this.props;
		this.svgAnimation = new StatusAnimation(
			this.container,
			elementSize,
			Config.running.amplitude,
			Config.running.speed,
			Config.running.color,
			"running"
		);
		this.svgAnimation.start(Config.running.frameRate);
	}

	runErrorAnimation = () => {
		const { elementSize } = this.props;
		this.svgAnimation = new StatusAnimation(
			this.container,
			elementSize,
			Config.error.amplitude,
			Config.error.speed,
			Config.error.color,
			"error"
		);
		this.svgAnimation.start(Config.error.frameRate);
	};

	runIdlingAnimation = () => {
		const { elementSize } = this.props;
		this.svgAnimation = new StatusAnimation(
			this.container,
			elementSize,
			Config.idling.amplitude,
			Config.idling.speed,
			Config.idling.color,
			"idling"
		);
		this.svgAnimation.start(Config.idling.frameRate);
	};

	render() {
		const { size, elementSize, children } = this.props;
		const midpoint = (size - elementSize) * 0.5;
		const placement = { left: midpoint, top: midpoint };

		switch (children) {
			case "running": {
				return (
					<div style={{ width: size, height: size }} className="status-wrapper" data-testid="status-running">
						<div
							className="indicator"
							style={{
								width: elementSize,
								height: elementSize,
								...placement,
							}}
						>
							<div
								className="svg-wrapper"
								style={{
									width: elementSize - 4,
									height: elementSize - 4,
								}}
							>
								<div
									style={{
										position: "absolute",
										top: -2,
										left: -2,
									}}
								>
									<svg width={elementSize} height={elementSize}>
										<g
											transform="translate(0, 0)"
											ref={(node) => {
												this.container = node;
											}}
										/>
									</svg>
								</div>
							</div>
						</div>
					</div>
				);
			}

			case "error": {
				return (
					<div style={{ width: size, height: size }} className="status-wrapper" data-testid="status-error">
						<div
							className="indicator"
							style={{
								width: elementSize,
								height: elementSize,
								...placement,
							}}
						>
							<div
								className="svg-wrapper"
								style={{
									width: elementSize - 4,
									height: elementSize - 4,
								}}
							>
								<div
									style={{
										position: "absolute",
										top: -2,
										left: -2,
									}}
								>
									<svg width={elementSize} height={elementSize}>
										<g
											transform="translate(0, 0)"
											ref={(node) => {
												this.container = node;
											}}
										/>
									</svg>
								</div>
							</div>
						</div>
					</div>
				);
			}

			default:
			case "idle": {
				return (
					<div style={{ width: size, height: size }} className="status-wrapper" data-testid="status-idle">
						<div
							className="indicator"
							style={{
								width: elementSize,
								height: elementSize,
								...placement,
							}}
						>
							<div
								className="svg-wrapper"
								style={{
									width: elementSize - 4,
									height: elementSize - 4,
								}}
							>
								<div
									style={{
										position: "absolute",
										top: -2,
										left: -2,
									}}
								>
									<svg width={elementSize} height={elementSize}>
										<g
											transform="translate(0, 0)"
											ref={(node) => {
												this.container = node;
											}}
										/>
									</svg>
								</div>
							</div>

							{/* <div className="hover-info" style={{ width: 80, left: -(80 - elementSize) / 2 }}>
                                <div className="triangle" />
                                <div className="label">No Tasks</div>
                            </div> */}
						</div>
					</div>
				);
			}
		}
	}
}
